import React from 'react';
import './styles.scss';
import { useTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import { getShortMonths } from '../../utils/Helpers/MapperHelper';

const SupervitionResumeGraph = ({ chart, title }) => {
    const { t } = useTranslation();

    const data = {
        labels: getShortMonths(),
        datasets: [
            {
                label: t('projected_progress'),
                type: "bar",
                data: chart.map((item) => item.projected),
                backgroundColor: "#D0D5E0",
                borderColor: "#D0D5E0",
                borderWidth: 2,
                order: 1,
                barThickness: 15
            },
            {
                label: t('actual_progress'),
                type: "bar",
                data: chart.map((item) => item.current),
                backgroundColor: "#416DBC",
                borderColor: "#416DBC",
                borderWidth: 2,
                order: 2,
                barThickness: 15
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                display: false,
            },
        },
        scales: {
            xAxes: [
                {
                    gridLines: { display: false },
                    ticks: { fontSize: 14 }
                }
            ],
            yAxes: [
                {
                    scaleLabel: {
                        display: true,
                    },
                    gridLines: { display: true },
                    ticks: {
                        fontSize: 15,
                        beginAtZero: true,
                        min: 0,
                    },
                }
            ],
        },
        legend: {
            display: false
        }
    };

    return (
        <div className='supervition-resume-graph'>
            <h3 className='chart-subtitle-focus'>{title}</h3>
            <Bar data={data} options={options} redraw={true} />
        </div>
    );
}

export default SupervitionResumeGraph;
